(() => {
  if (customElements.get('bm-routine-quiz')) return;
  const familyKeys = {
    'vit-b12': ['vit-b12', 'vitamina-b12', 'b12', 'vit-b'],
    'vit-b': ['vit-b', 'vit-b12', 'vitamina-b12', 'b12', 'vit-b1', 'vit-b2', 'vit-b3', 'vit-b5', 'vit-b6', 'vit-b7', 'vit-b9'],
    magneziu: ['magneziu', 'magnesium', 'mg'],
    'vit-c': ['vit-c', 'vitamina-c', 'vitaminc'],
    'vit-d': ['vit-d', 'vit-d3', 'vitamina-d', 'vitamina-d3'],
    calciu: ['calciu', 'calcium', 'ca'], zinc: ['zinc', 'zn'], seleniu: ['seleniu', 'selenium', 'se'], melatonina: ['melatonina', 'melatonin']
  };
  const normalKey = (key) => String(key).trim().toLowerCase().replace(/_/g, '-');
  const aliases = (key) => {
    const normalized = normalKey(key);
    const family = familyKeys[normalized] || Object.values(familyKeys).find((keys) => keys.includes(normalized));
    return family || [normalized];
  };
  const normalizedTokens = (product) => [...new Set([...(Array.isArray(product.tokens) ? product.tokens : []), ...product.groups].flatMap(aliases))];
  const validProduct = (product) => product && typeof product.handle === 'string' && Number.isSafeInteger(Number(product.variant)) && Number(product.variant) > 0 && Number.isFinite(product.price) && product.price >= 0 && Number.isFinite(product.days) && product.days > 0 && Array.isArray(product.goals) && Array.isArray(product.groups) && product.groups.length;
  const chooseProducts = (products, answers) => {
    const existing = Array.isArray(answers.existing) ? answers.existing : [];
    if (!['18-44', '45-64', '65plus'].includes(answers.age) || existing.includes('context')) return [];
    if (!['mixed', 'lowanimal', 'vegan'].includes(answers.diet)) return [];
    const used = new Set(existing.filter((key) => key !== 'none').flatMap(aliases));
    const variants = new Set();
    const limit = answers.age === '65plus' ? 2 : 3;
    const budget = Number(answers.budget);
    if (!Number.isFinite(budget) || budget < 0) return [];
    const candidates = products.filter((product) => validProduct(product) && product.available === true && product.goals.includes(answers.goal) && (answers.diet !== 'vegan' || product.vegan === true)).map((product, index) => ({...product, rank: index + (product.groups.includes('vit-b12') ? answers.diet === 'lowanimal' ? -10 : 10 : 0)})).sort((first, second) => first.rank - second.rank);
    const chosen = [];
    let daily = 0;
    for (const product of candidates) {
      const tokens = normalizedTokens(product);
      const perDay = product.price / product.days;
      if (variants.has(String(product.variant)) || tokens.some((token) => used.has(token))) continue;
      if (budget && daily + perDay > budget + 0.0001) continue;
      chosen.push(product);
      daily += perDay;
      variants.add(String(product.variant));
      tokens.forEach((token) => used.add(token));
      if (chosen.length === limit) break;
    }
    return chosen;
  };
  class BiomeRoutineQuiz extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      try { this.catalogue = JSON.parse(this.querySelector('[data-quiz-products]').textContent); } catch (_) { return; }
      if (!Array.isArray(this.catalogue.products)) return;
      this.form = this.querySelector('[data-quiz-form]');
      this.flow = this.querySelector('[data-quiz-flow]');
      this.results = this.querySelector('[data-quiz-results]');
      this.startButton = this.querySelector('[data-quiz-start]');
      this.startLabel = this.querySelector('[data-quiz-start-label]');
      this.startIcon = this.querySelector('[data-quiz-start-icon]');
      if (!this.form || !this.flow || !this.results || !this.startButton || !this.startLabel || !this.startIcon) return;
      const templateHandles = new Set(Array.from(this.querySelectorAll('[data-quiz-card]'), (item) => item.dataset.quizCard));
      this.catalogue.products = this.catalogue.products.filter((product) => validProduct(product) && templateHandles.has(product.handle));
      this.initialized = true;
      this.step = 0;
      this.view = 'flow';
      this.opened = false;
      this.hasStarted = false;
      this.flow.hidden = true;
      this.results.hidden = true;
      this.startButton.setAttribute('aria-expanded', 'false');
      this.startButton.addEventListener('click', () => this.opened ? this.close() : this.start());
      this.form.addEventListener('submit', (event) => this.next(event));
      this.form.addEventListener('change', (event) => this.changed(event));
      this.form.addEventListener('keydown', (event) => { if (event.key === 'Escape') { event.preventDefault(); this.close(); } });
      this.results.addEventListener('keydown', (event) => { if (event.key === 'Escape') { event.preventDefault(); this.close(); } });
      this.querySelector('[data-quiz-back]').addEventListener('click', () => {
        if (this.step > 0) { this.step -= 1; this.showStep(); } else this.close();
      });
      this.querySelector('[data-quiz-restart]').addEventListener('click', () => {
        this.form.reset();
        this.step = 0;
        this.view = 'flow';
        this.start();
      });
      this.querySelector('[data-quiz-close]').addEventListener('click', () => this.close());
      this.querySelector('[data-quiz-fallback]').hidden = true;
      this.startButton.hidden = false;
    }
    start() {
      this.opened = true;
      this.hasStarted = true;
      this.startButton.setAttribute('aria-expanded', 'true');
      this.startLabel.textContent = 'Închide quizul';
      this.startIcon.textContent = '−';
      this.dispatchEvent(new CustomEvent('bm:quiz-start', {bubbles: true}));
      this.flow.hidden = this.view !== 'flow';
      this.results.hidden = this.view !== 'results';
      if (this.view === 'results') this.querySelector('[data-quiz-result-title]').focus({preventScroll: true});
      else this.showStep();
    }
    close() {
      this.opened = false;
      this.flow.hidden = true;
      this.results.hidden = true;
      this.startButton.setAttribute('aria-expanded', 'false');
      this.startLabel.textContent = this.view === 'results' ? 'Vezi din nou rezultatul' : this.hasStarted ? 'Continuă quizul' : 'Găsește punctul de plecare';
      this.startIcon.textContent = '↗';
      this.startButton.focus({preventScroll: true});
    }
    showStep() {
      this.querySelector('[data-quiz-error]').hidden = true;
      this.form.querySelectorAll('[data-quiz-step]').forEach((fieldset, index) => {
        fieldset.hidden = index !== this.step;
        fieldset.removeAttribute('aria-describedby');
      });
      this.querySelector('[data-quiz-progress]').textContent = `Întrebarea ${this.step + 1} din 5`;
      this.querySelector('progress').value = this.step + 1;
      this.querySelector('[data-quiz-back]').textContent = this.step === 0 ? 'Închide quizul' : 'Înapoi';
      this.querySelector('[data-quiz-next]').textContent = this.step === 4 ? 'Vezi formulele →' : 'Mai departe →';
      this.form.querySelector(`[data-quiz-step="${this.step}"] legend`).focus({preventScroll: true});
    }
    changed(event) {
      this.querySelector('[data-quiz-error]').hidden = true;
      if (event.target.name !== 'existing') return;
      if (event.target.value === 'none' && event.target.checked) this.form.querySelectorAll('[name="existing"]').forEach((input) => { if (input !== event.target) input.checked = false; });
      else if (event.target.checked) this.form.querySelector('[name="existing"][value="none"]').checked = false;
    }
    next(event) {
      event.preventDefault();
      if (!this.opened || this.view !== 'flow') return;
      const fieldset = this.form.querySelector(`[data-quiz-step="${this.step}"]`);
      if (!fieldset.querySelector('input:checked')) {
        const error = this.querySelector('[data-quiz-error]');
        error.hidden = false;
        fieldset.setAttribute('aria-describedby', error.id);
        fieldset.querySelector('input').focus();
        return;
      }
      if (this.step < 4) { this.step += 1; this.showStep(); return; }
      const values = new FormData(this.form);
      this.renderResult({goal: values.get('goal'), age: values.get('age'), diet: values.get('diet'), existing: values.getAll('existing'), budget: values.get('budget')});
    }
    renderResult(answers) {
      const products = chooseProducts(this.catalogue.products, answers);
      const cardHolder = this.querySelector('[data-quiz-cards]');
      cardHolder.replaceChildren();
      const money = new Intl.NumberFormat('ro-RO', {style: 'currency', currency: this.catalogue.currency || 'RON'});
      for (const product of products) {
        const template = Array.from(this.querySelectorAll('[data-quiz-card]')).find((item) => item.dataset.quizCard === product.handle);
        const card = template.content.cloneNode(true);
        card.querySelector('[data-quiz-daily]').textContent = `${money.format(product.price / product.days / 100)} / zi · ${product.days} zile de utilizare`;
        cardHolder.appendChild(card);
      }
      const title = this.querySelector('[data-quiz-result-title]');
      const note = this.querySelector('[data-quiz-result-note]');
      const total = this.querySelector('[data-quiz-total]');
      const routine = this.querySelector('[data-quiz-routine]');
      routine.hidden = !products.length;
      if (products.length) routine.href = `${routine.getAttribute('href').split('#')[0]}#produse=${products.map((product) => product.variant).join(',')}`;
      const constrained = answers.age === 'under18' || answers.existing.includes('context');
      title.textContent = constrained ? 'Hai să verificăm contextul întâi.' : products.length ? 'Un punct de plecare pentru tine.' : 'Mai bine alegem formula cu atenție.';
      note.textContent = answers.age === 'under18' ? 'Pentru cei sub 18 ani, alegerea și doza se discută cu medicul sau farmacistul. Poți folosi catalogul pentru a citi formulele.' : answers.existing.includes('context') ? 'Dacă există un tratament, o afecțiune, sarcină sau alăptare, contextul merită verificat înainte de alegere. Pentru formulele pe care le iei deja, verificăm întâi ingredientele și dozele cu medicul sau farmacistul.' : !products.length && answers.diet === 'vegan' ? 'Nu am găsit în selecția quizului o formulă disponibilă, confirmată vegan și compatibilă cu răspunsurile tale. Consultă formula completă și materialul capsulei în catalog sau întreabă-ne despre un produs.' : !products.length ? 'Nu am găsit în selecția quizului o formulă disponibilă care să respecte împreună bugetul și ingredientele pe care le iei deja. Poți compara separat produsele din catalog.' : `Am păstrat ${products.length === 1 ? 'o formulă' : `${products.length} formule`} de explorat pentru interesul ales, ${Number(answers.budget) ? 'în bugetul indicat' : 'cu prețul pe zi la vedere'} și fără dublarea ingredientelor cunoscute. Prețurile sunt cele standard; ofertele personalizate se văd în pagina produsului.`;
      total.hidden = !products.length;
      if (products.length) total.textContent = `Cost cumulat orientativ: ${money.format(products.reduce((sum, product) => sum + product.price / product.days, 0) / 100)} / zi.`;
      this.view = 'results';
      this.flow.hidden = true;
      this.results.hidden = false;
      title.focus({preventScroll: true});
    }
  }
  customElements.define('bm-routine-quiz', BiomeRoutineQuiz);
})();
